import {Component, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from "@wms/components";
import {CommonModule} from "@angular/common";
import {Config, NewProps, PrefabConfigurationService, removeUndefinedKeys, _removeProperty} from "@wms/settings/prefab-config";
import {capitalize, extend, forEach, includes, isEqual} from "lodash-es";
import {FormsModule, NgForm} from "@angular/forms";
import {getClonedObject, initCaps, isDefined, runtimeEventManager} from "@wm/core";
import {Subscription} from "rxjs";
import { BasePrefabConfigTab } from '../base-tab-component/base-prefabconfig-tab-component.component';

@Component({
  selector: 'wms-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.less'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class EventsComponent extends BasePrefabConfigTab implements OnInit {
  prefabLifecycleEvents: string[];
  newProps: NewProps;
  events: any[];
  formValueChangesSubscription: Subscription;
  @ViewChild('eventsForm', {static: true}) override eventsForm: NgForm;

  constructor() {
    super();
    this.prepareModelForDisplay(this.prefabConfigService.getConfig());
    this.prefabLifecycleEvents = ['Load', 'Destroy'];
    this.newProps = this.prefabConfigService.newProps;
    this.newProps['event'] = {};
    this.registerDestroyListener.add(runtimeEventManager.on('prepare-events-save').subscribe(() => {
      this.prepareForSave();
    }));
  }

  ngOnInit() {
    let setInitialValue: boolean = true;
    if (this.initialEvents) {        
      setInitialValue = false;
    }
    this.formValueChangesSubscription = this.eventsForm.form.valueChanges.subscribe(() => {
      if (!this.eventsForm.form.dirty && setInitialValue) {
        this.initialEvents = this.eventsForm.form.value;
      } 
      this.prefabConfigService.isInvalid['events'] = this.eventsForm.form.invalid;
      if(this.eventsForm.form.dirty && !isEqual(this.initialEvents,this.eventsForm.form.value))
        this.setDirty();

    });

    this.resetFormSubscription = this.prefabConfigService.resetForm.subscribe((resetInitialVal) => {
      if (!resetInitialVal) {
        this.prepareModelForDisplay(this.prefabConfigService.getConfig());
      }
    });
  }

  setDirty() {
    this.prefabConfigService.isDirty['events'] = true;
  }

  prepareModelForDisplay(config: Config) {
    this.prefabConfig = config;
    let events: any = config.events || {};
    events = Object.keys(events).map( (eventName: any) => {
      let event = events[eventName];
      eventName = eventName.replace('on', '');
      //if the property is load or destroy do not display these
      if (includes(this.prefabLifecycleEvents, eventName)) {
        this.setDirty();
        return;
      }
      return extend({}, {name: eventName}, event);
    });
    this.events = removeUndefinedKeys(events);
  }

  prepareForSave() {
    let events: any = {}, eventsObj = getClonedObject(this.events);
    forEach(eventsObj, (event:any)=> {
      if (!event.name)
        return;

      event.name = initCaps(event.name);
      if (includes(this.prefabLifecycleEvents, event.name))
        return;

      event.name = 'on' + event.name;
      let eventObj = {
        description: isDefined(event.description) ? event.description : '',
        eventData: isDefined(event.eventData) ? event.eventData : '',
        displayName: isDefined(event.displayName) ? event.displayName : ''
      };
      events[event.name] = eventObj;
    });
    this.prefabConfig.events = events;
  }

  validateEvents(event: any, isNewEvent: boolean) {
    event.name = event.name.toLowerCase()
    event.displayName = event.displayName || capitalize(event.name);
    if (isNewEvent) {
      this.addEvent();
    }
  }

  addEvent() {
    let newEventProp = this.newProps['event'];
    if (!newEventProp || !newEventProp.name) {
      return;
    }
    if (includes(this.prefabLifecycleEvents, capitalize(newEventProp.name))) {
      this.newProps['event'] = {};
      return;
    }
    newEventProp.widget = 'eventlist';
    this.events.push(newEventProp);
    this.prefabConfig.events = this.events;
    this.setDirty();
    this.newProps['event'] = {};
    setTimeout(function () {
      $('table.events tr:nth-last-child(2) td:nth-child(2) input').focus();
    });
  }

  removeEvent(event: any) {
    _removeProperty(this.events, event);
    this.prefabConfig.events = this.events;
    this.setDirty();
  };

  override ngOnDestroy() {
    this.formValueChangesSubscription.unsubscribe();
  }
}
